import React from "react";
import { createPortal } from "react-dom";
import { ExternalLink } from "lucide-react";
import { DETAIL_BACKDROP } from "../../theme/sharedStyles";

// Shown in place of the text Google writes into a Google Task's description:
// edits made in Clarity don't reach Google for these, so point to where they do.
export function GoogleTaskLink({ url }) {
  if (!url) return null;
  return (
    <a href={url} target="_blank" rel="noopener noreferrer"
      style={{ display: "inline-flex", alignItems: "center", gap: 9, fontSize: 13, fontWeight: 600, color: "var(--c-text-accent)", textDecoration: "underline", textUnderlineOffset: 3 }}>
      <ExternalLink size={14} /> Edit in Google Tasks
    </a>
  );
}

// Shown instead of the delete confirm for a Google Task: Clarity's Google
// connection has Calendar permission only, so it can't delete the task on Google,
// and a local delete would just come back on the next sync (Jade picked this over
// adding Google Tasks permission, 2026-10-20). Deleting it in Google Tasks removes
// it from Clarity on the next sync (src/google/sync.js).
export function GoogleTaskDeleteNotice({ url, onClose }) {
  return createPortal(
    <div onClick={onClose}
      style={{ position: "fixed", inset: 0, zIndex: 100001, ...DETAIL_BACKDROP, display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }}>
      <div onClick={e => e.stopPropagation()}
        style={{ width: "min(360px, 92vw)", background: "var(--c-bg-card)", borderRadius: 22, padding: "22px 22px 18px", boxShadow: "0 14px 50px rgba(212,120,154,0.28)", fontFamily: "'Quicksand', sans-serif", textAlign: "center" }}>
        <div style={{ fontSize: 16, fontWeight: 800, color: "var(--c-text)", marginBottom: 8 }}>Delete it in Google Tasks</div>
        <div style={{ fontSize: 13, fontWeight: 600, color: "var(--c-text-mid)", lineHeight: 1.5, marginBottom: 18 }}>
          This task comes from Google Tasks, and Clarity can't delete it there. Delete it in Google Tasks and it will leave Clarity on the next sync.
        </div>
        <div style={{ display: "flex", gap: 10 }}>
          <button onClick={onClose}
            style={{ flex: 1, padding: "11px", borderRadius: 14, border: "1.5px solid var(--c-border)", background: "var(--c-bg-card)", color: "var(--c-text)", fontSize: 13, fontWeight: 800, cursor: "pointer", fontFamily: "inherit" }}>
            OK
          </button>
          {url && (
            <a href={url} target="_blank" rel="noopener noreferrer" onClick={onClose}
              style={{ flex: 1, padding: "11px", borderRadius: 14, background: "var(--c-primary)", color: "var(--c-on-primary, #fff)", fontSize: 13, fontWeight: 800, textDecoration: "none", display: "flex", alignItems: "center", justifyContent: "center", gap: 6 }}>
              <ExternalLink size={14} /> Open Google Tasks
            </a>
          )}
        </div>
      </div>
    </div>,
    document.body
  );
}
